import React from 'react';
import useIntersectionObserver from './useIntersectionObserver';

interface TrackableComponentProps {
    onIntersect: () => void;
    children: React.ReactNode;
    threshold?: number;
}

const TrackableComponent: React.FC<TrackableComponentProps> = (props) => {
    const { onIntersect, children, threshold = 0.7 } = props;
    const ref = useIntersectionObserver(
        ([entry], observer) => {
            if (entry.isIntersecting) {
                onIntersect();
                observer.disconnect();
            }
        },
        { threshold: threshold },
    );

    return <div ref={ref}>{children}</div>;
};

export default TrackableComponent;
